'use client';

import { useTourPartnerName } from './useTourPartnerName';

type TTourPartnerNameProps = {
    regularName: string;
    partnerId: string;
};

export const TourPartnerName = ({ regularName, partnerId }: TTourPartnerNameProps) => {
    const partnerName = useTourPartnerName(regularName, partnerId);

    return partnerName;
};
